import {
  ActionButton,
  ButtonCont,
  ButtonsCont,
  CompanyText,
  DatesLocationInfo,
  DescriptionText,
  HiddenRoles,
  Labels,
  LabelsCont,
  MainInfo,
  ProjectHeader,
  ProjectItemCont,
  ProjectRoleCont,
  ProjectText,
  RateInfo,
} from './ProjectItem.styles';
import RoleItem from './RoleItem/RoleItem';
import React, { useEffect, useMemo, useState } from 'react';
import ProjectDetails from './ProjectDetails/ProjectDetails';
import { useProjectItemDataParser } from './useProjectItemDataParser';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_ICON, PRIMARY_TEXT, ERROR_ICON, PRIMARY_BUTTON_BACKGROUND, DARK_GREEN_TEXT, DARK_GREEN_ICON } = COLORS;
import { LuArrowDown, LuArrowUp, LuShare2 } from 'react-icons/lu';
import { CircularProgress, Hidden, IconButton, Popover, useTheme } from '@material-ui/core';
import { IoClose } from 'react-icons/io5';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { CustomTooltip } from '../../CustomTooltip/CustomTooltip';
import { FaUndo } from 'react-icons/fa';
import { CheckMarkIcon } from '@room-match/shared-ui-components';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { CONFIG } from 'shared/config';
import { Skeleton } from '@material-ui/lab';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
interface Props {
  project: IProjectAttributes;
  projectType: 'new' | 'submitted' | 'not_interested';
}

const { fetchProjectRolesData } = opportunitiesServices();

const ProjectItem: React.FC<Props> = ({ project, projectType }) => {
  const isDark = useTheme().palette.type === 'dark';

  const isJobs = useContextSelector(OpportunitiesContext, (state) => state.isJobs);
  const removeProject = useContextSelector(OpportunitiesContext, (state) => state.removeProject);
  const reactivateProject = useContextSelector(OpportunitiesContext, (state) => state.reactivateProject);
  const openOpportunityModal = useContextSelector(OpportunitiesContext, (state) => state.openOpportunityModal);
  const { id: projectId, slug } = project;
  const {
    companyName,
    projectName,
    union,
    dates,
    location,
    roles,
    rate,
    release,
    type,
    casting_roles,
    unmatchedRoles,
    noticeboard_project_name,
    noticeboard_company_name,
  } = useProjectItemDataParser(project);

  const [rolesExcept, setrolesExcept] = useState<string[]>([]);
  const { data, isLoading: fetchingMoreRoles } = fetchProjectRolesData(projectId, rolesExcept);

  const [viewMore, setViewMore] = useState(false);
  const expand = () => setViewMore((prev) => !prev);

  // const [projectRolesData, setprojectRolesData] = useState<IRoleAttributes[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [showMoreRoles, setShowMoreRoles] = useState(false);

  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  //usememo for projectRolesData using data
  const projectRolesData = useMemo(() => {
    if (!fetchingMoreRoles) {
      return data?.data.casting_role_opportunities_connection.nodes || [];
    }
    return [];
  }, [data, fetchingMoreRoles]);

  const copyLink = (event: React.MouseEvent<HTMLButtonElement>) => {
    // if (anchorEl !== null) return;
    // //copy to clipboard
    // navigator.clipboard.writeText(`${CONFIG.JOBS_APP_URL}/${projectId}`);
    // setAnchorEl(event.currentTarget);
    // setTimeout(() => {
    //   handleClose();
    // }, 1500);
    openOpportunityModal('share', `${CONFIG.JOBS_APP_URL}/${slug}`, projectName);
  };

  const handleRemoveProject = () => {
    if (projectType === 'submitted') return;
    if (projectType === 'not_interested') {
      return reactivateProject(projectId);
    }
    removeProject(projectId);
  };

  // useEffect(() => {
  //   console.log('ProjectItem Rendered', projectName);
  // });

  const getMoreRoles = async () => {
    if (showMoreRoles) return setShowMoreRoles(false);
    if (projectRolesData.length) return setShowMoreRoles(true);
    if (fetchingMoreRoles) return;
    setrolesExcept(casting_roles.map((r) => r.id));
    setShowMoreRoles(true);
  };

  return (
    <ProjectItemCont>
      <ProjectHeader>
        <MainInfo>
          <CustomTooltip title={noticeboard_project_name || projectName}>
            <ProjectText>{noticeboard_project_name || projectName}</ProjectText>
          </CustomTooltip>
          <CompanyText>
            {noticeboard_company_name || companyName}
            {noticeboard_company_name ? (
              <CustomTooltip title="This is a well-known established Casting Companies, choosing to not disclose their names to avoid over-solicitation. Rest assured they are legitimate casting companies, screened by us, with full intent of posting work on this noticeboard.">
                <IoInformationCircleOutline fontSize={16} color={PRIMARY_ICON} style={{ alignSelf: 'center' }} />
              </CustomTooltip>
            ) : (
              <React.Fragment />
            )}
          </CompanyText>
        </MainInfo>
        <Hidden mdDown>
          <LabelsCont>
            <Labels>Type: </Labels>
            <Labels>Union: </Labels>
            <Labels>Date: </Labels>
          </LabelsCont>
          <DatesLocationInfo>
            <DescriptionText>{type}</DescriptionText>
            <DescriptionText>{union}</DescriptionText>
            <DescriptionText>{dates}</DescriptionText>
          </DatesLocationInfo>
          <LabelsCont rate={1}>
            <Labels>Location: </Labels>
            <Labels>Usage / Run: </Labels>
            <Labels>Rate: </Labels>
          </LabelsCont>
          <DatesLocationInfo style={{ flex: 1 }}>
            <DescriptionText>{location}</DescriptionText>
            <CustomTooltip title={release}>
              <DescriptionText>{release}</DescriptionText>
            </CustomTooltip>
            <CustomTooltip title={rate}>
              <DescriptionText style={{}}>{rate}</DescriptionText>
            </CustomTooltip>
          </DatesLocationInfo>
          <LabelsCont rate={1}>
            <Labels>Roles: </Labels>
          </LabelsCont>
          <RateInfo>
            <DescriptionText>{roles}</DescriptionText>
          </RateInfo>
        </Hidden>

        <Hidden mdDown>
          <ButtonCont>
            <IconButton onClick={copyLink}>
              <LuShare2 color={PRIMARY_ICON} size={22} />
            </IconButton>
            <ButtonsCont>
              {!isJobs() ? (
                <ActionButton
                  variant="outlined"
                  negative={1}
                  onClick={handleRemoveProject}
                  green={+Boolean(projectType === 'submitted' || projectType === 'not_interested')}
                >
                  {projectType === 'submitted' ? 'Submitted' : projectType === 'new' ? 'Not Interested' : 'Reactivate'}
                </ActionButton>
              ) : (
                <React.Fragment />
              )}

              <ActionButton variant="outlined" onClick={expand} style={{ color: isDark ? 'white' : PRIMARY_TEXT }}>
                {viewMore ? 'View Less' : 'View More'}
              </ActionButton>
            </ButtonsCont>
          </ButtonCont>
        </Hidden>
        {/* mobile view */}
        <Hidden lgUp>
          <ButtonCont isRow={+Boolean(projectType === 'submitted')}>
            <ButtonsCont>
              <ActionButton variant="outlined" onClick={copyLink}>
                <LuShare2 color={PRIMARY_ICON} size={22} />
              </ActionButton>
              {projectType === 'submitted' || isJobs() ? (
                <React.Fragment />
              ) : (
                <ActionButton
                  variant="outlined"
                  negative={1}
                  green={projectType === 'not_interested' ? 1 : 0}
                  onClick={handleRemoveProject}
                >
                  {projectType === 'new' ? <IoClose size={22} color={ERROR_ICON} /> : <FaUndo />}
                </ActionButton>
              )}
            </ButtonsCont>
            {projectType === 'submitted' || isJobs() ? (
              <ActionButton fullWidth variant="outlined" onClick={expand}>
                {viewMore ? (
                  <LuArrowUp size={20} color={PRIMARY_ICON} />
                ) : (
                  <LuArrowDown size={20} color={PRIMARY_ICON} />
                )}
              </ActionButton>
            ) : (
              <ActionButton
                fullWidth
                variant="outlined"
                onClick={expand}
                style={{ color: isDark ? 'white' : PRIMARY_BUTTON_BACKGROUND }}
              >
                {viewMore ? 'View Less' : 'View More'}
              </ActionButton>
            )}
          </ButtonCont>
        </Hidden>
      </ProjectHeader>
      {/* View More Mobile extra header */}
      <Hidden lgUp smDown>
        <ProjectHeader responsive={1}>
          <LabelsCont>
            <Labels>Type: </Labels>
            <Labels>Union: </Labels>
            <Labels>Date: </Labels>
          </LabelsCont>
          <DatesLocationInfo>
            <DescriptionText>{type}</DescriptionText>
            <DescriptionText>{union}</DescriptionText>
            <DescriptionText>{dates}</DescriptionText>
          </DatesLocationInfo>
          <LabelsCont rate={1}>
            <Labels>Location: </Labels>
            <Labels>Release: </Labels>
            <Labels>Rate: </Labels>
          </LabelsCont>
          <DatesLocationInfo>
            <DescriptionText>{location}</DescriptionText>
            <CustomTooltip title={release}>
              <DescriptionText>{release}</DescriptionText>
            </CustomTooltip>
            <CustomTooltip title={rate}>
              <DescriptionText style={{}}>{rate}</DescriptionText>
            </CustomTooltip>
          </DatesLocationInfo>

          <LabelsCont rate={1} style={{ marginLeft: 'auto' }}>
            <Labels>Roles: </Labels>
          </LabelsCont>
          <RateInfo>
            <DescriptionText>{roles}</DescriptionText>
          </RateInfo>
        </ProjectHeader>
      </Hidden>
      <Hidden mdUp>
        <ProjectHeader responsive={1}>
          <Labels>Type: </Labels>
          <DescriptionText>{type}</DescriptionText>
          <Labels>Union: </Labels>
          <DescriptionText>{union}</DescriptionText>
          <Labels>Release: </Labels>
          <DescriptionText>{release}</DescriptionText>

          <Labels>Dates: </Labels>
          <DescriptionText>{dates}</DescriptionText>
          <Labels>Location: </Labels>
          <DescriptionText>{location}</DescriptionText>
          <Labels>Rate: </Labels>
          <DescriptionText>{rate}</DescriptionText>

          <Labels>Roles: </Labels>
          <DescriptionText>{roles}</DescriptionText>
        </ProjectHeader>
      </Hidden>
      {viewMore ? <ProjectDetails projectId={projectId} /> : <React.Fragment />}

      <ProjectRoleCont>
        {casting_roles.map((r) => (
          <RoleItem
            type={projectType}
            key={r.id}
            role={r}
            projectId={projectId}
            companyName={noticeboard_company_name || companyName}
            projectName={projectName}
            projectSlug={slug}
          />
        ))}
      </ProjectRoleCont>
      {unmatchedRoles ? (
        <HiddenRoles
          style={{
            marginBottom: projectRolesData.length && showMoreRoles ? 0 : 15,
          }}
          onClick={getMoreRoles}
          // disabled={projectRolesData.length > 0}
        >
          {fetchingMoreRoles ? (
            <CircularProgress size={20} />
          ) : (
            <CustomTypography fontSize={12}>
              {showMoreRoles ? 'Hide ' : 'Show '}
              <span style={{ fontWeight: 700 }}>{unmatchedRoles}</span> more
              {unmatchedRoles > 1 ? ' Roles' : ' Role'}{' '}
              {projectType === 'submitted' ? '' : 'not matching your criteria'}
            </CustomTypography>
          )}
        </HiddenRoles>
      ) : (
        <React.Fragment />
      )}

      {projectRolesData.length && showMoreRoles ? (
        <ProjectRoleCont>
          {projectRolesData.map((r) => (
            <RoleItem
              notYetSubmitted
              type={projectType}
              key={r.id}
              role={r}
              projectId={projectId}
              companyName={noticeboard_company_name || companyName}
              projectName={projectName}
              projectSlug={slug}
            />
          ))}
        </ProjectRoleCont>
      ) : (
        <React.Fragment />
      )}

      {fetchingMoreRoles ? (
        <div style={{ display: 'flex', gap: 15, flexDirection: 'column', padding: '0 15px 15px 15px' }}>
          {Array.from({ length: 2 }).map((_, i) => (
            <Skeleton variant="rect" width={'100%'} height={80} />
          ))}
        </div>
      ) : (
        <React.Fragment />
      )}
      {open ? (
        <Popover
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={open}
        >
          <div style={{ padding: 10, display: 'flex', gap: 5, alignItems: 'center' }}>
            <CheckMarkIcon htmlColor={DARK_GREEN_ICON} fontSize="small" />
            <CustomTypography fontSize={14} style={{ color: DARK_GREEN_TEXT }} fontWeight={700}>
              Link Copied!
            </CustomTypography>
          </div>
        </Popover>
      ) : null}
    </ProjectItemCont>
  );
};

export default React.memo(ProjectItem);
